export default __webpack_public_path__ + "static/media/left.f9f6cda5.svg";